<template>
  <div class="services">
    <div class="services-content">
      <div class="services-left">
        <div class="services-top">
          <h4>IT Поддръжка</h4>
          <span>Компютърни услуги, поддръжка на хардуер и софтуер</span>
        </div>
        <div class="row">
          <div class="video" @click="isModalOpened = true">
            <img src="/static/img/services/thumb.webp" />
            <p>
              <strong>Представяне от управителя</strong>
            </p>
            <p>
              Кратко представяне на фирма Си Дотс от нейния управител, за
              създаването до сега
            </p>
          </div>
          <div class="header-ps">
            <p>
              Изграждане на ИТ инфраструктура - мрежи, сървъри, виртуални
              работни пространства
            </p>
            <p>Продажба, обслужване, доставка и отдаване на техника под наем</p>
            <p>Поддръжка на техника, обучение на кадри, специални изпълнения</p>
          </div>
        </div>
        <div class="showcase-new">
          <!-- <p>Изграждане на ИТ инфраструктура - мрежи, сървъри, виртуални работни пространства</p> -->
          <img class="showcase-new-img" src="/static/img/services/1.svg"
            title="Изграждане на ИТ инфраструктура - мрежи, сървъри, виртуални работни пространства" />
          <!-- <p>Продажба, обслужване, доставка и отдаване на техника под наем</p> -->
          <img class="showcase-new-img" src="/static/img/services/2.svg"
            title="Продажба, обслужване, доставка и отдаване на техника под наем<" />
          <!-- <p>Поддръжка на техника, обучение на кадри, специални изпълнения</p> -->
          <img class="showcase-new-img" src="/static/img/services/3.svg"
            title="Поддръжка на техника, обучение на кадри, специални изпълнения" />
        </div>
        <div class="showcase-new">
          <img class="showcase-new-img" width="100%" src="/static/img/services/sertTitle.svg"
            title="Си Дотс е сертифицирана със следните международни CompTIA A+ сертификати" />
          <img class="showcase-new-img" width="100%" src="/static/img/services/sert901.svg"
            title="Си Дотс е сертифицирана със следните международни CompTIA A+ сертификати" />
          <img class="showcase-new-img" width="100%" src="/static/img/services/sert902.svg"
            title="Си Дотс е сертифицирана със следните международни CompTIA A+ сертификати" />
        </div>
      </div>
      <div class="services-right">
        <div class="services-top">
          <h4>Ценова листа за услуги</h4>
            <span>Цени на нашите услуги може да разгледате в долната таблица</span>
            <span>
              или директно свалете в
              <a href="/static/cDots-Price-List.pdf" target="_blank">PDF файл</a>
            </span>
          <br />
          <span>
            <strong>Минимални пакети за годишна поддръжка - с подписване на договор за 12 месеца*:</strong>
          </span> <br>
          <span>
            <table class="prices">

              <tr>
                <td>➡️ <strong>Изградени системи за управление <br />на бизнес/администрация</strong> </td>
                <td>мин. 10 включени часа, 79 лв./час, <br /> всеки допълнителен час 89 лв.
                </td>
              </tr>
              <tr>
                <td>➡️ <strong>Изградени уеб страници</strong> </td>
                <td>мин. 2 включени часа, 79 лв./час, <br /> всеки допълнителен час 89 лв.
                </td>
              </tr>
              <tr>
                <td>➡️ <strong>Поддръжка на ИТ инфраструктура</strong> </td>
                <td>мин. 4 включени часа, 79 лв./час, <br /> всеки допълнителен час 89 лв.
                </td>
              </tr>
            </table>
            <span>
              <i>* посочените цени са без ДДС</i>
            </span>
          </span>
          <br />
          <span>
            <strong>Цени за услуги без активен годишен договор за абонаментно обслужване**:</strong>
          </span> <br>
          <span>
            <table class="prices">
              <tr>
                <td>➡️ <strong>Услуги по подръжка на компютри, <br />свързана техника и ИТ инфраструктура</strong> </td>
                <td></td>
                <td></td>
                <td></td>
                <td>89 лв./час</td>
              </tr>
              <tr>
                <td>➡️ <strong>Услуги по разрботка на решения и поддръжка на<br /> разработени решения (програмистки
                    труд)</strong> </td>
                <td></td>
                <td></td>
                <td></td>
                <td>160 лв./час</td>
              </tr>
            </table>
            <span>
              <i>* посочените цени са без ДДС</i> <br>
              <i>** посочените цени се заплащат авансово</i>
            </span>
          </span>
        </div>
        <!-- Таблица с цените, закоментирана -->
        <!-- <div class="tablebox">
          <table class="prices">
            <thead>
              <tr>
                <th
                  colspan="4"
                >1. Посещение на място от сервизен специалист без договор за абонаментна поддръжка</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.1</td>
                <td>Посещение на сервизен специалист в рамките на населеното място</td>
                <td>29.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>1.2</td>
                <td>Допълнителни транспортни разходи извън рамките на населеното място (до клиента и обратно)</td>
                <td>0.39  лв.</td>
                <td>На km</td>
              </tr>
              <tr>
                <th colspan="4">2. ИТ хардуерни услуги</th>
              </tr>
              <tr>
                <td>2.1</td>
                <td>Асемблиране на персонален компютър в офис на Си Дотс</td>
                <td>19.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.2</td>
                <td>Инсталиране и пускане в експлоатация на персонален компютър при клиента</td>
                <td>24.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.3</td>
                <td>Инсталиране и пускане в експлоатация на персонален компютър при клиента с настройка на мрежовата среда, файлови и принтерни услуги, интернет, поща, потребителски интерфейс</td>
                <td>49.90 лв</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.4</td>
                <td>Инсталиране на хардуерни компоненти: дънна платка, процесор, памет, твърд диск, компакт дисково у-во и др.</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.5</td>
                <td>Инсталиране на персонален принтер: матричен, мастилено-струен, лазерен</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.6</td>
                <td>Инсталиране на мрежов принтер: матричен, мастилено-струен, лазерен</td>
                <td>14.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.7</td>
                <td>Инсталиране и настройка на плотер (линеен принтер)</td>
                <td>39.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.8</td>
                <td>Инсталиране и настройка на персонален скенер</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.9</td>
                <td>Инсталиране и настройка за работа на документен скенер</td>
                <td>14.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.10</td>
                <td>Инсталиране и настройка за работа на факс апарат</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.11</td>
                <td>Инсталиране и настройка за работа на цветен лазерен принтер</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.12</td>
                <td>Инсталиране и настройка за работа на многофункционално устройство</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.13</td>
                <td>Инсталиране и настройка за работа на мултимедиен прожектор</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.14</td>
                <td>Инсталиране и настройка на непрекъсваемо токозахранващо у-во (UPS) Персонално</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.15</td>
                <td>Инсталиране и настройка на непрекъсваемо токозахранващо у-во (UPS) мрежово</td>
                <td>49.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.16</td>
                <td>Инсталиране и настройка на компютърен TV тунер</td>
                <td>14.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.17</td>
                <td>Инсталиране и настройка на мултимедийна система</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>2.18</td>
                <td>Монтаж, инсталиране и настройка на DVR</td>
                <td>89.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.19</td>
                <td>Монтаж, инсталиране и настройка на камера за видео наблюдение</td>
                <td>49.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.20</td>
                <td>Инсталиране на архивиращо устройство с архивиращ софтуер на сървър</td>
                <td>89.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.21</td>
                <td>Асемблиране и хардуерно конфигуриране на сървър</td>
                <td>89.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.22</td>
                <td>Инсталиране и хардуерно конфигуриране на клъстер</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>2.23</td>
                <td>Инсталиране и настройка на NAS</td>
                <td>49.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>2.24</td>
                <td>Инсталиране и настройка на SAN</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>2.25</td>
                <td>Инсталиране и настройка на персонални идентификационни устройства</td>
                <td>39.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <th colspan="4">3. Диагностика и ремонт</th>
              </tr>
              <tr>
                <td>3.1</td>
                <td>Диагностика и отстраняване на хардуерни проблеми в сървърни платформи</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>3.2</td>
                <td>Диагностика и отстраняване на софтуерни проблеми в сървърни платформи</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>3.3</td>
                <td>Диагностика и ремонт на компютърна техника (компютри, монитори, UPS и др.)</td>
                <td>14.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <th colspan="4">4. Профилактика</th>
              </tr>
              <tr>
                <td>4.1</td>
                <td>Хардуерна профилактика на персонален компютър</td>
                <td>24.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>4.2</td>
                <td>Хардуерна профилактика на преносим компютър</td>
                <td>24.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>4.3</td>
                <td>Софтуерна профилактика на сървър</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>4.4</td>
                <td>Откриване и отстраняване на вируси и зловреден код</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <th colspan="4">5. Инсталиране и преинсталиране на (само) лицензиран софтуер</th>
              </tr>
              <tr>
                <td>5.1</td>
                <td>Инсталиране / преинсталиране на драйвери на хардуерно устройство</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>5.2</td>
                <td>Инсталиране и настройка на настолна операционна система (Windows, Linux) На компютър (декстоп/лаптоп)</td>
                <td>49.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>5.3</td>
                <td>Преинсталиране и настройка на настолна операционна система (Windows, Linux) на персонален компютър със запазване на клиентските данни</td>
                <td>89.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>5.4</td>
                <td>Възстановяване и настройка на фабричната персонална операционна система (Windows, Linux) на персонален/преносим компютър със запазване на клиентските данни</td>
                <td>89.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>5.5</td>
                <td>Архивиране на клиентски данни от персонален/преносим компютър</td>
                <td>24.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>5.6</td>
                <td>Инсталиране и настройка на приложен софтуер: Microsoft, Adobe, Autodesk, Corel и др.</td>
                <td>24.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>5.7</td>
                <td>Инсталиране и настройка на антивирусно сървърно приложение – Kaspersky, Microsoft, Panda, Trend micro и др.</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.8</td>
                <td>Инсталиране и настройка на антивирусно персонално приложение – Kaspersky, Microsoft, Panda, Trend micro и др.</td>
                <td>14.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>5.9</td>
                <td>Инсталиране и настройка на Microsoft Windows server – базова инсталация на сървър, конфигуриране на домейн, настройка на политики за сигурност, настройка на DNS, DHCP, WINS, FTP услуги</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.10</td>
                <td>Инсталиране и настройка на Hypervisor (MICROSOFT HYPER-V, VMWARE ESXI, VSPHERE, XEN PROJECT HYPERVISOR, KVM)</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.11</td>
                <td>Конфигуриране на Microsoft terminal services in Windows server</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.12</td>
                <td>Инсталиране и настройка на Microsoft Exchange server</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.13</td>
                <td>Инсталиране и настройка на пощенски сървър базиран на дистрибуция с отворен код (Zimbra, Postfix mail server)</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.14</td>
                <td>Инсталиране и настройка на Microsoft SQL server</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.15</td>
                <td>Администриране на Microsoft SQL server</td>
                <td>69.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.16</td>
                <td>Инсталиране и настройка на пощенски сървър базиран на дистрибуция с отворен код</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.17</td>
                <td>Инсталиране и настройка на corporate FTP server</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.18</td>
                <td>Администриране на мрежова операционна система/домейн структури: Microsoft, Linux</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.19</td>
                <td>Преинсталиране и на мрежова операционна система: Microsoft, Linux с миграция на системни и потребителски данни</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.20</td>
                <td>Инсталиране на приложен софтуер на сървърна платформа: Microsoft, Linux</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.21</td>
                <td>Инсталиране на софтуер за управление и одит на информационната система</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.22</td>
                <td>Възстановяване работоспособността на повредена сървърна os</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>5.23</td>
                <td>Мигриране на домейн структури, базирани на Microsoft сървърни платформи</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <th colspan="4">6. Инсталация на пасивно мрежово оборудване</th>
              </tr>
              <tr>
                <td>6.1</td>
                <td>Изтегляне на меден/оптичен кабел в подземно кабелно трасе</td>
                <td>3.99  лв.</td>
                <td>На метър</td>
              </tr>
              <tr>
                <td>6.2</td>
                <td>Изтегляне на меден/оптичен кабел във въздушно кабелно трасе</td>
                <td>14.90  лв.</td>
                <td>На метър</td>
              </tr>
              <tr>
                <td>6.3</td>
                <td>Изтегляне на меден/оптичен кабел по фасадата на сграда</td>
                <td>14.90  лв.</td>
                <td>На метър</td>
              </tr>
              <tr>
                <td>6.4</td>
                <td>Изтегляне на меден кабел в сграда</td>
                <td>1.99  лв.</td>
                <td>На метър</td>
              </tr>
              <tr>
                <td>6.5</td>
                <td>Изтегляне на оптичен кабел в сграда</td>
                <td>1.99  лв.</td>
                <td>На метър</td>
              </tr>
              <tr>
                <td>6.6</td>
                <td>Полагане на HDPE тръба 32/40 mm в изкоп</td>
                <td>3.99  лв.</td>
                <td>На метър</td>
              </tr>
              <tr>
                <td>6.7</td>
                <td>Въвеждане на меден/оптичен кабел в сграда</td>
                <td>199.00  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.8</td>
                <td>Пробиване на отвори в сграда</td>
                <td>19.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.9</td>
                <td>Полагане на гофрирана тръба</td>
                <td>3.99  лв.</td>
                <td>На метър</td>
              </tr>
              <tr>
                <td>6.10</td>
                <td>Монтаж на канали</td>
                <td>3.99  лв.</td>
                <td>На метър</td>
              </tr>
              <tr>
                <td>6.11</td>
                <td>Монтаж на кабелна скара</td>
                <td>9.99  лв.</td>
                <td>На метър</td>
              </tr>
              <tr>
                <td>6.12</td>
                <td>Монтаж и аранжиране на комуникационен шкаф (6u-27u)</td>
                <td>199.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.13</td>
                <td>Монтаж и аранжиране на сървърен/комуникационен шкаф</td>
                <td>199.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.14</td>
                <td>Монтаж стенна розетка</td>
                <td>14.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.15</td>
                <td>Терминиране на меден конектор неекраниран</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.16</td>
                <td>Терминиране на меден конектор екраниран</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.17</td>
                <td>Монтаж на подова розетка единична</td>
                <td>49.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.18</td>
                <td>Монтаж на подова розетка</td>
                <td>89.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.19</td>
                <td>Монтаж и терминиране на съединителен (patch) панел 24 порта неекранирани</td>
                <td>199.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.20</td>
                <td>Монтаж и терминиране на съединителен (patch) панел 24 порта екранирани</td>
                <td>199.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.21</td>
                <td>Монтаж и терминиране на съединителен (patch) панел 48 порта неекранирани</td>
                <td>399.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.22</td>
                <td>Монтаж и терминиране на съединителен (patch) панел 48 порта екранирани</td>
                <td>399.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.23</td>
                <td>Монтаж на контакт шуко</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.24</td>
                <td>Монтаж на контакт за шина</td>
                <td>9.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.25</td>
                <td>Направа на ел. Разклонителна кутия</td>
                <td>19.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>6.26</td>
                <td>Изготвяне на документация за завършен обект</td>
                <td>24.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <th
                  colspan="4"
                >7. Инсталация и настройка на активно мрежово и комуникационно оборудване</th>
              </tr>
              <tr>
                <td>7.1</td>
                <td>Монтаж и инсталация на неуправляем мрежов комутатор</td>
                <td>19.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>7.2</td>
                <td>Монтаж и инсталация на управляем мрежов комутатор L2</td>
                <td>24.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>7.3</td>
                <td>Монтаж и инсталация на управляем мрежов комутатор L3</td>
                <td>49.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>7.4</td>
                <td>Монтаж и инсталация на безжична мрежова точка</td>
                <td>24.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>7.5</td>
                <td>Монтаж и инсталация на broadband router</td>
                <td>49.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>7.6</td>
                <td>Монтаж и инсталация на мрежов router</td>
                <td>89.90  лв.</td>
                <td>На брой</td>
              </tr>
              <tr>
                <td>7.7</td>
                <td>Монтаж, инсталация и настройка на firewall устройство</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>7.8</td>
                <td>Монтаж, инсталация и настройка на antispam устройства</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>7.9</td>
                <td>Монтаж, инсталация и настройка на internet application security устройства</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>7.10</td>
                <td>Монтаж, инсталация и настройка на устройства за антивирусна защита</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>7.11</td>
                <td>Инсталация и настройка на VOIP телефонна централа Asterisk, вкл. Интерактивна система за гласови отговори (IVR), конферентни връзки, билинг, графичен интерфейс за справки и др.</td>
                <td>89.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <th colspan="4">8. Одиторска, проектантска и развойна дейност</th>
              </tr>
              <tr>
                <td>8.1</td>
                <td>Одит на информационна система</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>8.2</td>
                <td>Проектиране на цялостни инфраструктурни решения</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>8.3</td>
                <td>Проектиране на HIGH AVAILABILITY CLUSTERS решения</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>8.4</td>
                <td>Проектиране на DISASTER RECOVERY решения</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>8.5</td>
                <td>Проектиране на системи за видео наблюдение</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>8.6</td>
                <td>Проектиране на решения за непрекъснат работен процес</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>8.7</td>
                <td>Проектиране на решения за информационна сигурност</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <td>8.8</td>
                <td>Бюджетиране на информационни системи</td>
                <td>49.90  лв.</td>
                <td/час</td>
              </tr>
              <tr>
                <th colspan="4">9. отдаване под наем на ИТ техника</th>
              </tr>
              <tr>
                <td>9.1</td>
                <td>Мрежово оборудване (рутер, суич, други)</td>
                <td colspan="2">От 0.99 лв. До 2.99 лв./ден</td>
              </tr>
              <tr>
                <td>9.2</td>
                <td>ИТ оборудване (компютри, принтери, други)</td>
                <td colspan="2">От 2.99 лв. До 4.99 лв./ден</td>
              </tr>
              <tr>
                <th colspan="4">10. Услуги в извънработно време</th>
              </tr>
              <tr>
                <td>10.1</td>
                <td>Услуги, извършвани в интервала от 18.00 до 22.00 часа</td>
                <td colspan="2">Дължимата сума, + 50%</td>
              </tr>
              <tr>
                <td>10.2</td>
                <td>Услуги, извършвани в интервала от 22.00 до 08.00 часа</td>
                <td colspan="2">Дължимата сума, + 100%</td>
              </tr>
              <tr>
                <td>10.3</td>
                <td>Услуги, извършвани в неработни дни</td>
                <td colspan="2">Дължимата сума, + 100%</td>
              </tr>
              <tr>
                <td colspan="4" style="color:gray">
                  Всички цени са в лева с включен ДДС. ДДС в размер на 20% се начислява за всички стоки и услуги. Обявените цени и часови ставки се отнасят за услуги, извършвани в работен ден и в работното време на фирма СИДОТС ЕООД от 9.00 до 18.00 часа.
                  <br />Цените на услугите не включват цената на вложените резервни части и консумативи, ако това е наложително при извършването им.
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <table class="prices2">
            <tbody>
              <tr>
                <th colspan="4">11. Услуги за поддръжка на уеб страници и канали в социални мрежи</th>
              </tr>
              <tr>
                <td colspan="2">
                  <strong>Всяка седмица публикуване на продукт/услуга в социални мрежи:</strong>
                  <ul>
                    <li>Linkedin</li>
                    <li>Facebook</li>
                    <li>Instagram</li>
                  </ul>
                </td>
                <td colspan="2">280  лв.</td>
              </tr>
              <tr>
                <td colspan="2">
                  <strong>Всяка седмица публикуване на продукт/услуга в социални мрежи:</strong>
                  <ul>
                    <li>Linkedin</li>
                    <li>Facebook</li>
                    <li>Instagram</li>
                  </ul>+ Управление (модериране) на коментари 10 бр. На публикация, отговор, триене на лоши коментари и препоръки по продукти и услуги.
                </td>
                <td colspan="2">340  лв.</td>
              </tr>
              <tr>
                <td colspan="2">
                  <strong>Всяка седмица публикуване на продукт/услуга в социални мрежи:</strong>
                  <ul>
                    <li>Linkedin</li>
                    <li>Facebook</li>
                    <li>Instagram</li>
                    <li>Twitter</li>
                    <li>YouTube</li>
                  </ul>+ Управление (модериране) на коментари 10 бр. На публикация, отговор, триене на лоши коментари и препоръки по продукти и услуги.
                </td>
                <td colspan="2">480  лв.</td>
              </tr>
              <tr>
                <td colspan="2">
                  <strong>Всяка седмица публикуване на продукт/услуга в социални мрежи:</strong>
                  <ul>
                    <li>Linkedin</li>
                    <li>Facebook</li>
                    <li>Instagram</li>
                    <li>Twitter</li>
                    <li>YouTube</li>
                  </ul>+ Управление (модериране) на коментари до 10 бр. На публикация, отговор, триене на лоши коментари и препоръки по продукти и услуги. Два езика (бълг. + англ.).
                </td>
                <td colspan="2">580  лв.</td>
              </tr>
              <tr>
                <td colspan="2">
                  <strong>Всичко до тук</strong>
                  <br />+ участие, обсъждане и публикации в професионални форуми като BG MAMMA, VW CLUB и други в зависимост от дейност на фирмата, продуктите и услугите. Една тема на месец, до 10 отговора по теми свързани с продуктите.
                </td>
                <td colspan="2">680  лв.</td>
              </tr>
              <tr>
                <td colspan="4" style="color:gray">
                  Всяка една публикация (пост) в социалните мрежи се подготвя индивидуално с индивидуална визия и текст, като се изпраща за одобрение. След одобрение се публикува според избрания пакет, като в края на всеки месец се дава справка за достигнатата аудитория.
                  <br />Цените важат при подписване на едногодишен договор.
                  <br />Цена за допълнителна публикация – по-договаряне.
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->
      </div>
    </div>
    <!-- <div class="services-right">
      <div class="services-top">
        <h4>Запитване за услуги</h4>
        <span>Цени на нашите услуги може да разгледате в лeвият панел</span>
        <span>
          или директно свалете в
          <a href="/static/cDots-Price-List.pdf" target="_blank">PDF файл</a>
        </span>
      </div>
      <div class="services-right-form" v-if="!isSent">
        <div class="services-right-form-input">
          <label for="contactsName" :class="{ 'not-valid' : !isNameValid }">Вашето име</label>
          <input
            type="text"
            id="contactsName"
            :class="{ 'not-valid-border' : !isNameValid }"
            v-model="request.name"
          />
        </div>
        <div class="services-right-form-input">
          <label for="contactsEmail" :class="{ 'not-valid' : !isEmailValid }">e-mail</label>
          <input
            type="text"
            id="contactsEmail"
            :class="{ 'not-valid-border' : !isEmailValid }"
            v-model="request.email"
          />
        </div>
        <div class="services-right-form-input">
          <label for="contactsPhone" :class="{ 'not-valid' : !isPhoneValid }">Телефон</label>
          <input
            type="text"
            id="contactsPhone"
            :class="{ 'not-valid-border' : !isPhoneValid }"
            v-model="request.phone"
          />
        </div>
        <div class="services-right-form-input services-right-form-textarea">
          <label for="contactsMessage" :class="{ 'not-valid' : !isMessageValid }">Съобщение</label>
          <textarea
            id="contactsMessage"
            cols="30"
            rows="10"
            :class="{ 'not-valid-border' : !isMessageValid }"
            v-model="request.message"
          ></textarea>
        </div>
        <div class="btn-wrapper">
          <a class="services-right-form-submit" @click="sendInquiry(' за услуги')">
            <template v-if="isSent">Готово</template>
            <template v-else-if="isLoading && !isSent">Един момент</template>
            <template v-else>Изпрати</template>
          </a>
        </div>
      </div>
      <div class="services-success" v-if="isSent">
        <p>Запитването е изпратено успешно!</p>
        <p>Ще се свържем с вас до 48 часа.</p>
      </div>
      <p class="agreement">
        С изпращането на това запитване вие се съгласявате с
        <router-link
          class="link"
          to="/gdpr"
          target="_blank"
        >Нашата политика за поверителност на потребителските данни</router-link>.
      </p>
    </div>-->
    <Consultation />
    <transition name="fade">
      <Modal v-if="isModalOpened" :video="'https://www.youtube.com/embed/Rv_Z-3U8c0I'" />
    </transition>
  </div>
</template>

<script>
import sendInquiry from "./mixins/sendInquiry.js";
import Consultation from "./ConsultationServ";
import Modal from "./shared/Modal";
export default {
  components: {
    Consultation: Consultation,
    Modal: Modal,
  },
  mixins: [sendInquiry],
  data() {
    return {
      isModalOpened: false,
    };
  },
  mounted() {
    this.$on("close-modal", () => (this.isModalOpened = false));
  },
  destroyed() {
    this.$off("close-modal");
  },
};
</script>

<style scoped>
.services-content {
  display: flex;
  margin-top: -145px;
  height: 100vh;
}

/* table */
.tablebox {
  padding: 0px 30px;
  max-height: 80vh;
  overflow: auto;
}

.prices {
  background-color: rgb(255, 255, 255);
  color: black;
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}

.prices td {
  padding: 8px;
}

.prices tr {
  border: 4px solid rgb(238, 238, 238);
  padding: 8px;
}

.prices tr td:nth-child(3) {
  white-space: nowrap;
  text-align: right;
  font-weight: 700;
}

.prices th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #899aa2;
  color: white;
  text-transform: uppercase;
}

/* table 2*/
.prices2 {
  background-color: rgb(255, 255, 255);
  color: black;
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}

.prices2 td {
  padding: 18px;
}

.prices2 tr {
  border: 4px solid rgb(238, 238, 238);
  padding: 8px;
}

.prices2 tr td:nth-child(2) {
  white-space: nowrap;
  text-align: right;
  font-weight: 700;
}

.prices2 ul {
  padding: 4px 10px 5px 30px;
}

.prices2 th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #899aa2;
  color: white;
  text-transform: uppercase;
}

/* BOTH LEFT AND RIGHT SIDE */
.services-top {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: -25px;
  margin-bottom: 25px;
}

.services-top>h4 {
  color: #111;
}

.services-top>span {
  color: #111;
  font-size: 14px;
  line-height: 19px;
}

.services-top>span a {
  color: rgb(0, 140, 255);
  font-weight: 700;
  text-decoration: underline;
}

.services-left .services-top>h4,
.services-left .services-top>span {
  color: #000;
}

/* LEFT */
.services-left {
  align-items: center;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 160px 0 25px;
  width: 50%;
}

.row {
  align-items: center;
  display: flex;
  width: 90%;
  margin-bottom: 30px;
}

.header-ps {
  width: 50%;
}

.header-ps>p {
  margin-bottom: 15px;
  font-size: 16px;
  /* width: 90%; */
}

.header-ps>p:last-child {
  margin-bottom: 0;
}

.video {
  background-color: #f8f8f8;
  box-shadow: 0px 0px 99px #d4d4d4;
  margin: 10px 20px;
  width: 40%;
}

.showcase-new {
  align-items: center;
  display: flex;
  width: 80%;
}

.showcase-new p {
  display: none;
}

.showcase-new-img {
  width: calc(33.33% - 13.33px);
}

.showcase-new-img:not(:last-child) {
  margin-right: 20px;
}

.services-showcase {
  display: flex;
  display: none;
  flex-direction: column;
  padding-left: 100px;
  min-height: 1px;
  width: 100%;
}

.services-showcase-item {
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;
  padding-right: 50px;
  width: 100%;
}

.services-showcase-item-p {
  padding-left: 75px;
  width: 50%;
}

.services-showcase-item::before {
  background-color: #707070;
  border-radius: 50%;
  content: "";
  height: 27px;
  left: 30px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 27px;
}

.services-showcase-item::after {
  background-color: #707070;
  content: "";
  height: 50%;
  left: 43.5px;
  position: absolute;
  top: 50%;
  width: 1px;
}

.services-showcase-item:last-of-type {
  color: #5b5b5b;
}

.services-showcase-item:nth-of-type(2)::after {
  height: 100%;
  top: 0;
}

.services-showcase-item:nth-of-type(3)::after {
  top: 0;
}

.services-showcase-item-img {
  padding: 20px;
  width: 30%;
}

/* RIGHT */
.services-right {
  align-items: center;

  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 160px 0 25px;
  width: 50%;
}

.services-success p {
  color: #c4c4c4;
  font-size: 24px;
  text-align: center;
}

/* .services-right-form {
} */
.services-right-form-input {
  height: 60px;
  margin: 26px 0;
  position: relative;
  width: 410px;
}

.services-right-form-textarea {
  height: 110px;
}

.services-right-form-input>input,
.services-right-form-input>textarea {
  background-color: #313131;
  border: 1px solid #a7a7a7;
  border-radius: 8px;
  color: #fff;
  font-size: 16px;
  outline: none;
  padding: 0 25px;
  width: 100%;
  height: 60px;
}

.services-right-form-input>textarea {
  height: 110px;
  padding: 25px;
  resize: none;
}

.services-right-form-input>label {
  background-color: #313131;
  color: #fff;
  font-size: 16px;
  left: 15px;
  padding: 0 10px;
  position: absolute;
  top: -9px;
}

.btn-wrapper {
  padding-top: 10px;
  text-align: center;
  width: 100%;
}

.services-right-form-submit {
  align-items: center;
  background-color: #ffffff;
  color: #000;
  cursor: pointer;
  display: inline-flex;
  font-size: 18px;
  font-weight: 700;
  height: 45px;
  justify-content: center;
  width: 178px;
}

.services-right-form-submit:hover {
  background-color: #ebebeb;
}

.agreement {
  color: rgba(138, 138, 138, 0.8);
  font-size: 12px;
  text-align: center;
  margin: 15px 0;
  width: 410px;
}

.link {
  color: rgba(138, 138, 138, 0.8);
  text-decoration: underline;
}

@media screen and (max-width: 1920px) {
  .services-right {
    height: 100%;
  }
}

@media screen and (max-width: 1600px) {
  .services-right-form-input {
    height: 50px;
    margin: 20px 0;
    width: 350px;
  }

  .services-right-form-input>input {
    height: 50px;
  }

  .services-right-form-textarea,
  .services-right-form-input>textarea {
    height: 100px;
  }

  .btn-wrapper {
    padding-top: 0;
  }

  .services-showcase-item-p {
    font-size: 13px;
    width: 65%;
  }

  .services-showcase-item-img {
    padding: 10px;
    width: 20%;
  }

  .services-showcase-item::before {
    height: 20px;
    width: 20px;
  }

  .services-showcase-item::after {
    left: 40px;
  }

  .services-showcase-item-p {
    font-size: 12px;
  }

  .services-success p {
    font-size: 20px;
  }

  .header-ps {
    width: 60%;
  }
}

@media screen and (max-width: 1440px) {
  .services-top {
    margin-top: 15px;
  }

  .services {
    margin-top: -100px;
  }

  .services-left,
  .services-right {
    padding-top: 100px;
  }

  .services-right {
    height: 100%;
  }

  .services-right-form-submit {
    font-size: 14px;
  }

  .services-right-form-input>label {
    font-size: 14px;
    top: -8px;
  }
}

@media screen and (max-width: 1366px) {
  .services-top {
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .services-top>span {
    font-size: 12px;
  }

  .services-right {
    height: 104%;
  }

  .services-right-form-input {
    height: 40px;
    margin: 15px 0;
    width: 300px;
  }

  .services-right-form-input>label {
    font-size: 12px;
  }

  .services-right-form-input>input {
    font-size: 14px;
    height: 40px;
  }

  .services-right-form-textarea,
  .services-right-form-input>textarea {
    font-size: 14px;
    height: 80px;
  }

  .services-right-form-submit {
    height: 40px;
    width: 150px;
  }

  .agreement {
    font-size: 12px;
  }

  .row {
    margin: 2px 2px 2px 2px;
  }

  .showcase-new {
    margin: 2px 2px 2px 2px;
  }
}

@media screen and (max-width: 1280px) {
  .services-content {
    margin-top: -145px;
    height: 100vh;
    flex-direction: column;
    height: initial;
  }

  .services-left,
  .services-right {
    width: 100%;
  }

  .services-showcase {
    padding: 0 100px;
    flex-direction: row;
  }

  .row {
    align-items: center;
    flex-direction: column;
    width: 100%;
  }

  .header-ps {
    width: 100%;
  }

  .header-ps p {
    text-align: center;
    width: 100%;
  }

  .video {
    margin-bottom: 50px;
    margin-top: 50px;
  }

  .showcase-new {
    margin-top: 50px;
  }

  .services-right {
    padding: 50px 20px 63px;
  }

  .services-showcase-item {
    flex-direction: column-reverse;
    justify-content: flex-end;
    padding: 50px 0 0;
    width: 33.33%;
  }

  .services-showcase-item-img {
    width: 90%;
  }

  .services-showcase-item-p {
    padding: 25px 10px;
    text-align: center;
    width: 90%;
  }

  .services-showcase-item::before {
    display: none;
  }

  .services-showcase-item::after {
    display: none;
  }
}

@media screen and (max-width: 1000px) {
  .video {
    width: 50%;
  }

  .services-showcase {
    padding: 0 50px;
  }

  .services-showcase-item-p {
    padding: 10px;
  }
}

@media screen and (max-width: 800px) {
  .services-showcase {
    padding: 0 40px;
  }
}

@media screen and (max-width: 600px) {
  .services-top {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 25px;
    margin-bottom: -15px;
  }

  .header-ps {
    padding: 0px 20px 15px;
  }

  .services-showcase {
    flex-direction: column;
    padding: 15px 20px 0;
  }

  .video {
    width: calc(100% - 40px);
    margin-bottom: 10px;
  }

  .showcase-new {
    margin-top: 0;
    flex-direction: column;
  }

  .showcase-new-img:not(:last-child) {
    margin: 0 0 20px;
  }

  .showcase-new p {
    display: block;
    margin-bottom: 20px;
    text-align: center;
  }

  .showcase-new-img {
    width: 100%;
  }

  .services-right {
    padding-bottom: 50px;
  }

  .services-right-form,
  .agreement {
    width: 280px;
  }

  .services-right-form-input {
    width: 100%;
  }

  .services-showcase-item::before,
  .services-showcase-item::after {
    display: none;
  }

  .services-showcase-item {
    flex-direction: column;
    padding: 20px 0 0;
    width: 100%;
  }

  .services-showcase-item-p {
    padding: 0;
    text-align: center;
    width: 100%;
  }

  .services-showcase-item-img {
    width: 100%;
    padding: 20px 0;
  }
}</style>



// WEBPACK FOOTER //
// src/components/Services.vue